/**
 * Modül Menü Sözlüğü — TEK KAYNAK.
 * Hem Sidebar (NavGroup listeleri) hem Home (modül kartları) hem de
 * ModuleHub (alt-öğe tile'ları) buradan besleniyor.
 *
 * getModuleMenus(isAdmin) → ordered array of module groups.
 * Her grup: { slug, title, desc, icon, testId, items: [...] }
 * Her item: { to, label, icon, testId, end?, adminOnly? }
 */
import {
  House, Package, Truck, ChartLineUp, Users, UsersFour, Warehouse, WarningOctagon,
  ClockCounterClockwise, Lock, Cube, Buildings, UserGear, Archive,
  FileText, ShoppingBag, IdentificationBadge, CalendarBlank, Handshake, ChartBar, Envelope,
  ShieldStar, HardDrives, Tag, Receipt, Plus, ListChecks, ShieldCheck, UsersThree,
  CurrencyCircleDollar, TreeStructure, ChartLine, TrendUp, HardHat, Blueprint, Bank,
} from "@phosphor-icons/react";

export function getModuleMenus(isAdmin) {
  return [
    {
      slug: "stok-yonetimi",
      title: "Stok Yönetimi",
      desc: "Malzeme girişleri, stok listesi, irsaliye arşivi ve raporlar.",
      icon: Cube,
      testId: "group-stock",
      testIdCard: "home-mod-stock",
      items: [
        { to: "/stok-yonetimi", label: "Kontrol Paneli", icon: House, testId: "nav-dashboard", end: true },
        { to: "/malzeme-girisi", label: "Malzeme Girişi", icon: Package, testId: "nav-material-entry" },
        { to: "/stok", label: "Stok Listesi", icon: Warehouse, testId: "nav-inventory" },
        { to: "/irsaliye-arsivi", label: "İrsaliye Listesi", icon: Archive, testId: "nav-delivery-notes" },
        { to: "/raporlar", label: "Raporlar", icon: ChartLineUp, testId: "nav-reports" },
        { to: "/uyarilar", label: "Stok Uyarıları", icon: WarningOctagon, testId: "nav-alerts" },
      ],
    },
    {
      slug: "satin-alma-yonetimi",
      title: "Satın Alma Yönetimi",
      desc: "Teklif talepleri, sözleşmeler ve satın alma süreçleri.",
      icon: ShoppingBag,
      testId: "group-purchase",
      testIdCard: "home-mod-purchase",
      items: [
        { to: "/teklif-talepleri", label: "Teklif Talepleri", icon: Handshake, testId: "nav-rfq" },
        { to: "/gelen-teklifler", label: "Gelen Teklifler", icon: Envelope, testId: "nav-rfq-offers" },
        { to: "/sozlesmeler", label: "Sözleşmeler", icon: FileText, testId: "nav-contracts" },
        { to: "/satin-alma", label: "Satın Alma", icon: ShoppingBag, testId: "nav-purchase" },
        { to: "/satin-alma/rapor", label: "Raporlar", icon: ChartBar, testId: "nav-purchase-report" },
      ],
    },
    {
      slug: "proje-yonetimi",
      title: "Proje Yönetimi",
      desc: "Proje künyesi, WBS, iş kalemleri, ilerleme ve Gantt.",
      icon: Blueprint,
      testId: "group-project-mgmt",
      testIdCard: "home-mod-project",
      items: [
        { to: "/santiyeler", label: "Proje Künyesi", icon: Buildings, testId: "nav-sites" },
        { to: "/proje/mahal-yapisi", label: "Proje Yapısı", icon: Blueprint, testId: "nav-project-mahal" },
        { to: "/proje/wbs", label: "WBS Kırınımları", icon: TreeStructure, testId: "nav-wbs" },
        { to: "/proje/sorumluluk-kurallari", label: "Sorumluluk Kuralları", icon: UsersFour, testId: "nav-resp-rules" },
        { to: "/proje/work-items", label: "Work Item Yönetimi", icon: Package, testId: "nav-work-items" },
        { to: "/proje/ilerleme", label: "Proje İlerleme", icon: ChartLine, testId: "nav-project-progress" },
        { to: "/proje/gantt", label: "Gantt Şeması", icon: ChartBar, testId: "nav-project-gantt" },
      ],
    },
    {
      slug: "tedarikci-yonetimi",
      title: "Tedarikçi Yönetimi",
      desc: "Firma bilgileri ve tedarikçi kartları.",
      icon: Truck,
      testId: "group-supplier",
      testIdCard: "home-mod-supplier",
      items: [
        { to: "/firmalar", label: "Firma Bilgileri", icon: Truck, testId: "nav-suppliers" },
      ],
    },
    {
      slug: "personel-yonetimi",
      title: "Personel Yönetimi",
      desc: "Çalışanlar, ekipler, puantaj ve İK raporları.",
      icon: IdentificationBadge,
      testId: "group-personnel",
      testIdCard: "home-mod-hr",
      items: [
        { to: "/personel/calisanlar", label: "Personel Listesi", icon: IdentificationBadge, testId: "nav-employees" },
        { to: "/personel/ekipler", label: "Ekip Listesi", icon: UsersThree, testId: "nav-teams" },
        { to: "/personel/puantaj", label: "Puantaj", icon: CalendarBlank, testId: "nav-timesheet" },
        { to: "/personel/rapor", label: "Rapor", icon: ChartBar, testId: "nav-hr-report" },
      ],
    },
    {
      slug: "masraf-bildirimi",
      title: "Masraf Bildirimi",
      desc: "Yeni masraf, masraf listesi, talep formları ve onaylar.",
      icon: Receipt,
      testId: "group-expenses",
      testIdCard: "home-mod-expense",
      items: [
        { to: "/masraf/yeni", label: "Yeni Masraf", icon: Plus, testId: "nav-expense-new" },
        { to: "/masraf/liste", label: "Masraf Listesi", icon: ListChecks, testId: "nav-expense-list" },
        { to: "/masraf/talep-formlari", label: "Masraf Talep Formları", icon: FileText, testId: "nav-expense-claims" },
        ...(isAdmin ? [{ to: "/masraf/onaylar", label: "Masraf Onayları", icon: ShieldCheck, testId: "nav-expense-approvals" }] : []),
        { to: "/masraf/rapor", label: "Raporlar", icon: ChartBar, testId: "nav-expense-report" },
        ...(isAdmin ? [{ to: "/masraf/kategoriler", label: "Kategoriler", icon: Tag, testId: "nav-expense-categories" }] : []),
      ],
    },
    {
      slug: "butce-yonetimi",
      title: "Bütçe Yönetimi",
      desc: "Gelir/gider kayıtları, kırınım, kâr-zarar ve nakit akış.",
      icon: CurrencyCircleDollar,
      testId: "group-budget",
      testIdCard: "home-mod-budget",
      items: [
        { to: "/butce/giderler", label: "Gider Kayıtları", icon: CurrencyCircleDollar, testId: "nav-budget-expenses" },
        { to: "/butce/gelirler", label: "Gelir Kayıtları", icon: TrendUp, testId: "nav-budget-incomes" },
        { to: "/butce/kirinim", label: "Maliyet Kırınım Yapısı", icon: TreeStructure, testId: "nav-budget-cbs" },
        { to: "/butce/kar-zarar", label: "Kâr / Zarar (Ana İcmal)", icon: ChartBar, testId: "nav-budget-pl" },
        { to: "/butce/nakit-akis", label: "Nakit Akış Diyagramı", icon: ChartLine, testId: "nav-budget-cashflow" },
        { to: "/butce/hesaplar", label: "Hesaplar / Bankalar", icon: Bank, testId: "nav-budget-accounts" },
      ],
    },
    {
      slug: "alt-yuklenici-yonetimi",
      title: "Alt Yüklenici Yönetimi",
      desc: "Firma/ekip sözleşmeleri, hakediş, kesinti ve ödemeler.",
      icon: HardHat,
      testId: "group-subcontractor",
      testIdCard: "home-mod-subcontractor",
      items: [
        { to: "/taseron/firmalar", label: "Firma/Ekip Bilgileri", icon: Buildings, testId: "nav-sub-firms" },
        { to: "/taseron/sozlesmeler", label: "Firma/Ekip Sözleşmeleri", icon: FileText, testId: "nav-sub-contracts" },
        { to: "/taseron/hakedis", label: "Hakediş Yönetimi", icon: Receipt, testId: "nav-sub-progress" },
        { to: "/taseron/kesintiler", label: "Kesinti / Cezalar", icon: WarningOctagon, testId: "nav-sub-deductions" },
        { to: "/taseron/puantaj", label: "Puantaj / Devam", icon: CalendarBlank, testId: "nav-sub-attendance" },
        { to: "/taseron/odemeler", label: "Ödemeler", icon: CurrencyCircleDollar, testId: "nav-sub-payments" },
        { to: "/taseron/degerlendirme", label: "Değerlendirme / Puanlama", icon: ShieldStar, testId: "nav-sub-eval" },
        { to: "/taseron/raporlar", label: "Raporlar", icon: ChartBar, testId: "nav-sub-reports" },
      ],
    },
    {
      slug: "teklif-yonetimi",
      title: "Teklif Yönetimi",
      desc: "Müşterilere/ihale sahiplerine verilen taahhüt teklifleri.",
      icon: FileText,
      testId: "group-teklif",
      testIdCard: "home-mod-teklif",
      items: [
        { to: "/teklifler", label: "Teklif Listesi", icon: ListChecks, testId: "nav-teklif-list", end: true },
        { to: "/teklifler/yeni", label: "Yeni Teklif", icon: Plus, testId: "nav-teklif-new" },
      ],
    },
    {
      slug: "kullanici-islemleri",
      title: "Kullanıcı İşlemleri",
      desc: "Kullanıcılar, roller, ayarlar ve işlem geçmişi.",
      icon: UserGear,
      testId: "group-user",
      testIdCard: "home-mod-user",
      items: isAdmin
        ? [
            { to: "/kullanicilar", label: "Kullanıcılar", icon: Users, testId: "nav-users" },
            { to: "/kullanicilar/hr-rapor-alicilari", label: "İK Ayarları", icon: Envelope, testId: "nav-hr-recipients" },
            { to: "/roller-izinler", label: "Roller & İzinler", icon: ShieldStar, testId: "nav-roles" },
            { to: "/ayarlar/proje-tipleri", label: "Proje Tipleri", icon: Tag, testId: "nav-project-types" },
            { to: "/islem-gecmisi", label: "İşlem Geçmişi", icon: ClockCounterClockwise, testId: "nav-audit" },
            { to: "/yedekler", label: "Yedekler", icon: HardDrives, testId: "nav-backups" },
            { to: "/sifre-degistir", label: "Şifre İşlemleri", icon: Lock, testId: "nav-change-password" },
          ]
        : [
            { to: "/sifre-degistir", label: "Şifre İşlemleri", icon: Lock, testId: "nav-change-password" },
          ],
    },
  ];
}

export function findModuleBySlug(slug, isAdmin) {
  return getModuleMenus(isAdmin).find((m) => m.slug === slug) || null;
}

// ============================================================================
// Faz 50 — Path → Modül Slug çözümleyici.
// Herhangi bir sub-route'un hangi ana modüle ait olduğunu bulur. ModuleGuard
// bu fonksiyonla aktif path'in slug'ını bulur, user.module_access'te var mı
// diye kontrol eder.
// ============================================================================
export function getSlugForPath(pathname) {
  if (!pathname) return null;
  const menus = getModuleMenus(true); // isAdmin true → tüm item'ları gezer
  // Önce exact + prefix eşleşmesi ara (daha spesifik önce)
  let best = null;
  let bestLen = -1;
  for (const grp of menus) {
    for (const it of grp.items) {
      if (!it.to) continue;
      if (pathname === it.to || pathname.startsWith(it.to + "/")) {
        if (it.to.length > bestLen) {
          best = grp.slug;
          bestLen = it.to.length;
        }
      }
    }
  }
  return best;
}

// ============================================================================
// Modül erişim whitelist'i kapsamından TAMAMEN ÇIKARTILAN path'ler.
// Bu path'ler ya herkese açıktır (ör. /sifre-degistir, /erisim-yok) ya da
// zaten ayrı whitelist ile korunur (Finansal Kontrol, Gayri Resmi Kasa).
// ============================================================================
export const MODULE_ACCESS_EXEMPT_PREFIXES = [
  "/sifre-degistir",
  "/erisim-yok",
  "/profil",
  "/finansal-kontrol",     // kendi whitelist'i
  "/gayri-resmi-kasa",     // kendi whitelist'i
  "/ortaklar-carisi",      // kendi whitelist'i
  "/kullanicilar",         // admin-only
  "/islem-gecmisi",        // admin-only
  "/yedekler",             // admin-only
  "/roller-izinler",       // admin-only
  "/ayarlar",              // admin-only
];

export function isPathExemptFromModuleAccess(pathname) {
  if (!pathname) return true;
  if (pathname === "/" || pathname === "/home") return true;
  for (const p of MODULE_ACCESS_EXEMPT_PREFIXES) {
    if (pathname === p || pathname.startsWith(p + "/")) return true;
  }
  return false;
}
